import { getAccessTokenFromCookie } from "../util/authentication";
import { NOTIFICATION_API_GET_NOTIFICATIONS_BY_EMP } from "../util/constants";

export const fetchNotifications = async (eid) => {
  const apiEndpoint = process.env.REACT_APP_NOTIFICATION_API + NOTIFICATION_API_GET_NOTIFICATIONS_BY_EMP + "/" + eid;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const deleteNotifications = async (eid, notificationId) => {
  const apiEndpoint =
    process.env.REACT_APP_NOTIFICATION_API + eid + "/" + notificationId;
  const response = await fetch(apiEndpoint, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`POST ${apiEndpoint} API Call failed.\neid: ${eid}, notificationId: ${notificationId}`);
  }
  return response;
};
